// All translations FR / EN for VALTHELIS Avocats site
export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      cabinet: 'Le Cabinet',
      competences: 'Nos Compétences',
      formations: 'Les Formations',
      equipe: 'Notre Équipe',
      valeurs: 'Nos Valeurs',
      honoraires: 'Honoraires',
      contact: 'Contact',
    },
    common: {
      tagline: 'Avocats spécialisés en droit social',
      discover: 'Découvrir le cabinet',
      contactUs: 'Nous contacter',
      backToTop: 'Haut de page',
    },
    home: {
      title: 'Cabinet VALTHELIS Avocats',
      titleLine1: 'Cabinet',
      titleLine2: 'VALTHELIS Avocats',
      subtitle: 'Conseil et défense des entreprises en droit social',
      scrollHint: 'Découvrir',
    },
    cabinet: {
      title: 'Le Cabinet',
      kicker: 'Présentation',
      p1: "Le cabinet VALTHELIS Avocats conseille et défend les entreprises, quelle que soit leur taille, dans les domaines relevant du droit social, à savoir :",
      bullets: [
        'le droit du travail ;',
        'le droit de la sécurité sociale ;',
        'le droit de la protection sociale complémentaire ;',
      ],
      p2: "La mission du cabinet VALTHELIS Avocats est d'accompagner et de conseiller les entreprises au quotidien dans la gestion des relations du travail (tant individuelles que collectives) ou à l'occasion de missions spécifiques et ponctuelles en lien avec le droit social. Cet accompagnement, qu'il soit pérenne ou ponctuel, se doit de tenir compte des spécificités de l'entreprise, de ses contraintes et de sa stratégie globale.",
      objectiveLabel: 'Notre objectif',
      objective:
        "Identifier les solutions à la fois juridiques, pragmatiques et innovantes qui doivent être mises en œuvre pour régler de façon adaptée les problématiques de l'entreprise.",
      highlights: [
        { title: 'Droit social', text: 'Une expertise dédiée au droit du travail et à la protection sociale.' },
        { title: 'Conseil & contentieux', text: 'Accompagnement quotidien et défense devant toutes les juridictions.' },
        { title: 'Formation', text: "Organisme de formation déclaré, formations sur mesure pour vos équipes." },
        { title: 'Proximité', text: "Une relation privilégiée fondée sur la connaissance de votre environnement." },
      ],
    },
    competences: {
      title: 'Nos Compétences',
      kicker: 'Domaines d\u2019intervention',
      conseilTitle: 'Activité en Conseil',
      conseilIntro: 'Nous accompagnons les entreprises dans tous les domaines relevant du droit social et notamment :',
      conseilItems: [
        "La gestion des relations individuelles du travail (rédaction des contrats de travail, gestion des dossiers disciplinaires, sécurisation et mise en œuvre des procédures de licenciement, négociation de transaction…)",
        "La mise en place et la gestion des institutions représentatives du personnel",
        "La négociation avec les partenaires syndicaux (NAO, négociation d\u2019accords d\u2019entreprise)",
        "Les restructurations d\u2019entreprises (licenciements économiques individuels ou collectifs, gestion des plans de sauvegarde de l\u2019emploi, gestion des incidences sociales des transferts d\u2019activité et fusions)",
        "La durée et l\u2019aménagement du temps de travail",
        "Le statut des dirigeants de sociétés",
        "La réalisation d\u2019audits (audit d\u2019acquisition, de vente, pré-fusion)",
      ],
      contentieuxTitle: 'Assistance en cas de contentieux',
      contentieuxIntro: 'Nous assistons et représentons nos clients sur tout le territoire français, devant toutes les juridictions françaises :',
      contentieuxItems: [
        "Les contentieux Prud\u2019homaux",
        "Les contentieux devant la Cour d'Appel",
        "Les contentieux devant le Tribunal Judiciaire",
        "Les contentieux devant le Tribunal administratif pour les dossiers des salariés protégés",
      ],
    },
    formations: {
      title: 'Les Formations',
      kicker: 'Organisme de formation déclaré',
      intro: "Organisme de formation déclaré à la Préfecture, le Cabinet VALTHELIS Avocats propose aux entreprises et aux cabinets d\u2019expertise comptable, divers types de formations construites selon les besoins du client. Ainsi, nous animons des formations d\u2019actualité sociale ainsi que des formations sur des thèmes spécifiques ciblés et adaptés à la Convention Collective de l\u2019entreprise.",
      actuTitle: "Les formations d'actualité sociale",
      actuP1: "La gestion des ressources humaines nécessitant une attention particulière quant à l\u2019évolution de la législation et des positions jurisprudentielles de la Cour de Cassation, les formations d\u2019actualité sociale ont pour objectif de permettre à l\u2019entreprise et à ses collaborateurs une mise à jour régulière tout au long de l\u2019année de la règlementation sociale.",
      actuP2: "Ce programme de formations est en effet un outil indispensable pour permettre aux participants de renforcer leurs connaissances, de les mettre à jour et de répondre en même temps de manière directe et pratique à l\u2019ensemble de leurs questions et problématiques relatives au droit social.",
      actuP3: "Le module de formations d\u2019actualité sociale se présente sous la forme de plusieurs demi-journées ou journées par an, au cours desquelles sont examinées et commentées :",
      actuBullets: [
        "l\u2019actualité législative et règlementaire, sélectionnée en fonction de la taille de l\u2019entreprise et des sujets qui l\u2019intéresse en pratique ;",
        "l\u2019actualité jurisprudentielle, également sélectionnée en fonction de la nature des questions et dossiers que les collaborateurs de l\u2019entreprise rencontrent au quotidien ;",
      ],
      actuOutro: "Ces formations sont aussi l\u2019occasion d\u2019un temps d\u2019échange et de questions personnalisées.",
      themTitle: 'Les formations thématiques',
      themP1: "Ces formations permettent de faire un focus, le temps d\u2019une demi-journée ou d\u2019une journée entière, sur une problématique particulière sélectionnée par nos clients.",
      themP2: "Le Cabinet VALTHELIS Avocats propose dans ce cadre un large choix de thèmes permettant aux participants d\u2019acquérir les bases indispensables en lien avec le sujet traité ou de renforcer une certaine technicité lorsque le public participant à la formation détient déjà les bases nécessaires.",
      themP3: "De nombreux sujets peuvent être proposés, étant précisé qu\u2019il est également possible d\u2019élaborer des thèmes « sur mesure » en fonction des problématiques spécifiques des clients.",
      examplesTitle: 'Quelques exemples',
      examples: [
        "Éviter les pièges du contrat à durée déterminée (conclusion, gestion des renouvellements et rupture des CDD)",
        "Faire face aux situations d\u2019inaptitude, d\u2019invalidité et de mi-temps thérapeutique",
        "La difficile distinction entre modification du contrat de travail et modification des conditions de travail",
        "Les salariés à temps partiel",
        "La délicate gestion des dossiers d\u2019insuffisance professionnelle et des dossiers disciplinaires",
        "Faire face à un contrôle URSSAF",
        "Embaucher un salarié et rédiger son contrat de travail",
        "Comment gérer la suspension du contrat de travail pour cause de maladie ou d\u2019accident du travail",
        "Harcèlement moral et risques psycho-sociaux : comment agir ?",
        "Organiser dans l\u2019entreprise les élections des représentants du personnel",
        "La gestion pratique du temps de travail et des différents aménagements du temps de travail",
        "Mise en place du Comité Social et Économique (CSE)",
        "Fonctionnement, attributions et moyens du CSE",
        "Les droits et devoirs des représentants du personnel",
        "La gestion pratique des congés payés",
        "Les licenciements économiques : les pièges à éviter",
        "La responsabilité pénale du dirigeant",
      ],
    },
    equipe: {
      title: 'Notre Équipe',
      kicker: 'Une expertise reconnue, une approche humaine',
      members: {
        laurence: {
          name: 'Laurence VERDIER',
          role: 'Avocate associée',
          bio: [
            "Titulaire d\u2019un DESS de Droit des Affaires et Fiscalité ainsi que du Diplôme de Juriste Conseil en Entreprise (DJCE), Laurence Verdier a prêté serment en 1996.",
            "Après 19 ans passés au sein du cabinet Barthélémy et Associés puis au sein du cabinet Capstan, Laurence Verdier a fondé le cabinet Verdier Avocats en 2015 puis le cabinet VALTHELIS Avocats en 2024.",
            "Détentrice de la Spécialisation en Droit du travail, Droit de la sécurité sociale et de la protection sociale complémentaire, Laurence Verdier bénéficie d\u2019une expérience et d\u2019une pratique importante auprès des entreprises afin de les conseiller sur tous les aspects stratégiques et techniques du droit social.",
            "Laurence Verdier a développé également une activité significative en matière de formation en droit social qu\u2019elle dispense auprès des entreprises et cabinets d\u2019expertise comptable.",
            "Laurence Verdier est enfin chargée d\u2019enseignement depuis de nombreuses années à l\u2019Université Lyon 3 pour le Master 2 Droit des Affaires et Fiscalité/DJCE ainsi que pour le Master 2 Droit des Affaires et Fiscalité en formation continue.",
          ],
        },
        ageron: {
          name: 'Jean-Michel AGERON',
          role: 'Avocat associé',
          bio: [
            "Titulaire d\u2019un DESS de droit des affaires et d\u2019un DEA de Droit Social, Jean-Michel AGERON a prêté serment en 2001.",
            "Après une dizaine d\u2019années au sein du cabinet Barthélémy et Associés puis au sein du cabinet CAPSTAN, Jean-Michel AGERON a intégré le cabinet EY Société d\u2019Avocats en tant que Directeur Associé. Il a ensuite rejoint le cabinet ELLIPSE Avocats en tant qu\u2019Associé avant de fonder le cabinet VALTHELIS Avocats en 2024.",
            "Parfaitement bilingue, Jean-Michel AGERON accompagne au quotidien des entreprises françaises et étrangères sur les aspects juridiques des relations individuelles et collectives de travail ainsi qu\u2019en matière de protection sociale. Il a notamment développé une expertise en ce qui concerne les opérations de réorganisation d\u2019entreprises et de mises en œuvre de plan de sauvegarde de l\u2019emploi.",
            "Jean-Michel AGERON est enfin chargé d\u2019enseignement depuis de nombreuses années à l\u2019Université Lyon 3 pour le Master 2 Droit des Affaires et Fiscalité en formation continue et intervient régulièrement au sein de l\u2019EM Lyon.",
          ],
        },
        caroline: {
          name: 'Caroline BILLOTET',
          role: 'Avocate collaboratrice',
          bio: [
            "Caroline Billotet est titulaire d\u2019un Master 1 en Droit Social obtenu à l\u2019Université Jean Moulin Lyon 3 et un Master 2 en Droit du Sport obtenu à l\u2019Université de Lille.",
            "Après avoir obtenu le Certificat d\u2019Aptitude à la Profession d\u2019Avocat, Caroline Billotet a prêté serment en décembre 2023 devant la Cour d\u2019Appel de Lyon.",
            "Depuis, Caroline Billotet exerce en tant qu\u2019avocate collaboratrice au sein du Cabinet Valthelis Avocats et intervient notamment dans le domaine du conseil aux entreprises et en contentieux. Elle participe à l\u2019accompagnement des entreprises dans leurs besoins en matière de relations individuelles et collectives.",
            "Caroline Billotet est enfin chargée d\u2019enseignement à l\u2019Université Jean Moulin Lyon 3.",
          ],
        },
      },
    },
    valeurs: {
      title: 'Nos Valeurs',
      kicker: 'Notre engagement à votre service',
      items: [
        { title: 'Réactivité et rigueur', text: "Réactivité et rigueur dans le traitement de chaque dossier confié." },
        { title: 'Fiabilité', text: "Fiabilité dans les réponses apportées, compte tenu de notre spécialisation en droit social." },
        { title: 'Proximité', text: "Proximité avec nos clients et connaissance de leur environnement, de leur historique et de leur fonctionnement." },
        { title: 'Pragmatisme', text: "Pragmatisme dans la mise en œuvre des solutions préconisées." },
      ],
    },
    honoraires: {
      title: 'Honoraires',
      kicker: 'Une transparence totale',
      intro: "Les honoraires du Cabinet sont fixés en fonction de la nature et de la complexité de l'affaire et sont systématiquement annoncés aux clients préalablement à l'accomplissement des premières diligences, avec l\u2019établissement d\u2019une lettre de mission.",
      modesIntro: 'Plusieurs systèmes de facturation pourront être proposés aux clients :',
      modes: [
        {
          title: "L'abonnement annuel",
          text: "L\u2019abonnement est souvent utilisé pour les prestations de conseil aux entreprises. Il permet de lisser un montant d'honoraires défini en concertation avec chaque client en fonction de ses besoins. Cette formule assure un suivi régulier et contribue à une relation privilégiée entre l'avocat et son client.",
        },
        {
          title: 'Les honoraires à la vacation',
          text: "Pour les dossiers ponctuels en Conseil, les honoraires sont établis sur la base d\u2019un taux horaire déterminé et facturés en fonction du temps passé sur le dossier.",
        },
        {
          title: 'Les honoraires pour les dossiers contentieux',
          text: "Un montant d'honoraires forfaitaires englobant l'intégralité de la procédure est convenu avec le client.",
        },
      ],
    },
    contact: {
      title: 'Contact',
      kicker: 'Restons en contact',
      intro: "N\u2019hésitez pas à nous contacter pour toute demande d\u2019information ou de rendez-vous.",
      addressLabel: 'Adresse',
      phoneLabel: 'Secrétariat',
      emailsLabel: 'Adresses e-mail',
      mapLabel: 'Nous trouver',
      openInMaps: 'Ouvrir dans Google Maps',
    },
  },
  en: {
    nav: {
      home: 'Home',
      cabinet: 'The Firm',
      competences: 'Our Expertise',
      formations: 'Training',
      equipe: 'Our Team',
      valeurs: 'Our Values',
      honoraires: 'Fees',
      contact: 'Contact',
    },
    common: {
      tagline: 'Lawyers specialized in employment law',
      discover: 'Discover the firm',
      contactUs: 'Get in touch',
      backToTop: 'Back to top',
    },
    home: {
      title: 'Valthelis Law Firm',
      titleLine1: 'Valthelis',
      titleLine2: 'Law Firm',
      subtitle: 'Advising and defending businesses in employment law',
      scrollHint: 'Discover',
    },
    cabinet: {
      title: 'The Firm',
      kicker: 'Presentation',
      p1: 'Valthelis Law Firm advises and represents businesses of all sizes in the field of labor law, including:',
      bullets: [
        'Employment law',
        'Social security law',
        'Complementary social protection law',
      ],
      p2: "The mission of Valthelis Law Firm is to accompany and advise businesses on a daily basis in managing labor relations (both individual and collective) or during specific and occasional missions related to employment and labor law. This support, whether ongoing or occasional, must take into account the specificities of the company, its constraints, and its overall strategy.",
      objectiveLabel: 'Our goal',
      objective:
        "to identify legal, pragmatic, and innovative solutions that should be implemented to appropriately address the company's issues.",
      highlights: [
        { title: 'Employment Law', text: 'A dedicated expertise in labor law and social protection.' },
        { title: 'Counsel & Litigation', text: 'Daily support and defense before all jurisdictions.' },
        { title: 'Training', text: 'A registered training organisation, tailor-made programs for your teams.' },
        { title: 'Proximity', text: 'A privileged relationship rooted in the knowledge of your environment.' },
      ],
    },
    competences: {
      title: 'Our Expertise',
      kicker: 'Areas of practice',
      conseilTitle: 'Counsel',
      conseilIntro: 'We assist businesses in all major areas of employment law, including:',
      conseilItems: [
        'Management of individual employment relations (drafting employment contracts, handling disciplinary cases, securing and implementing dismissal procedures, negotiation of settlements…)',
        'Establishment and management of employee representative bodies',
        'Negotiation with union partners (collective bargaining agreements, negotiations)',
        'Company restructurings (individual or collective layoffs, management of jobs saving plans, handling social impacts of business transfers and mergers)',
        'Working time duration and arrangements',
        'Status of company executives',
        'Conducting audits (acquisition, sale, pre-merger audits)',
      ],
      contentieuxTitle: 'Litigation',
      contentieuxIntro: 'We represent our clients before all jurisdictions:',
      contentieuxItems: [
        'Labor court litigation',
        'Court of Appeal litigation',
        'Judicial Court litigation',
        'Administrative Court litigation for protected employees',
      ],
    },
    formations: {
      title: 'Training',
      kicker: 'Registered training organisation',
      intro: 'As a training organisation registered with the Prefecture, Valthelis Law Firm offers companies and accounting firms various types of training built around the client\u2019s needs. We provide both regulatory updates and tailored training on specific topics adapted to the company\u2019s collective bargaining agreement.',
      actuTitle: 'Regulatory update sessions',
      actuP1: 'As HR management requires close attention to changes in legislation and Supreme Court rulings, our regulatory update sessions allow companies and their teams to stay current with employment law throughout the year.',
      actuP2: 'This program is an essential tool for participants to strengthen and update their knowledge while answering, in a direct and practical way, the questions and issues they face on a daily basis.',
      actuP3: 'The regulatory update module takes the form of several half-days or full days per year, during which the following are reviewed and commented on:',
      actuBullets: [
        'Legislative and regulatory news, selected based on the size of the company and topics of practical interest',
        'Case law news, also selected based on the nature of the questions and files the company\u2019s teams handle daily',
      ],
      actuOutro: 'These sessions are also an opportunity for personalized exchanges and Q&A.',
      themTitle: 'Thematic training',
      themP1: 'These sessions allow a focused half-day or full-day deep dive into a specific issue selected by our clients.',
      themP2: 'Valthelis Law Firm offers a wide range of topics designed to provide participants with the essential foundations of the chosen subject or to strengthen technical mastery for participants already familiar with the basics.',
      themP3: 'Many subjects can be proposed, and we can also build fully bespoke programs based on the specific issues faced by clients.',
      examplesTitle: 'A few examples',
      examples: [
        'Avoiding the pitfalls of fixed-term contracts (conclusion, renewals, termination)',
        'Handling situations of unfitness for work, disability and therapeutic part-time',
        'The fine line between modification of the employment contract and of working conditions',
        'Part-time employees',
        'Managing professional inadequacy and disciplinary cases',
        'Facing a URSSAF audit',
        'Hiring an employee and drafting their employment contract',
        'Managing the suspension of the employment contract due to illness or work accident',
        'Moral harassment and psychosocial risks: how to act?',
        'Organising employee representative elections',
        'Practical management of working time and time arrangements',
        'Setting up the Social and Economic Committee (CSE)',
        'Operation, duties and resources of the CSE',
        'Rights and duties of employee representatives',
        'Practical management of paid leave',
        'Economic dismissals: pitfalls to avoid',
        "The director's criminal liability",
      ],
    },
    equipe: {
      title: 'Our Team',
      kicker: 'Recognized expertise, a human approach',
      members: {
        laurence: {
          name: 'Laurence VERDIER',
          role: 'Partner Lawyer',
          bio: [
            'Holder of a DESS in Business Law and Taxation as well as the Diploma of Corporate Legal Counsel (DJCE), Laurence Verdier was sworn in in 1996.',
            'After 19 years at Barthélémy et Associés and then at Capstan, Laurence Verdier founded Verdier Avocats in 2015 and then VALTHELIS Avocats in 2024.',
            'Holding the Specialization in Labor Law, Social Security Law and Complementary Social Protection, Laurence Verdier benefits from significant experience advising businesses on all strategic and technical aspects of employment law.',
            'Laurence Verdier has also developed a significant training activity in employment law (regulatory updates and thematic training) for businesses and accounting firms.',
            'She has been a lecturer for many years at Lyon 3 University for the Master 2 in Business Law and Taxation/DJCE as well as the Master 2 in Business Law and Taxation in continuing education.',
          ],
        },
        ageron: {
          name: 'Jean-Michel AGERON',
          role: 'Partner Lawyer',
          bio: [
            'Holder of a DESS in Business Law and a DEA in Employment Law, Jean-Michel AGERON was sworn in in 2001.',
            'After ten years at Barthélémy et Associés and then at CAPSTAN, Jean-Michel AGERON joined EY Société d\u2019Avocats as Associate Director. He then joined ELLIPSE Avocats as Partner before founding VALTHELIS Avocats in 2024.',
            'Perfectly bilingual, Jean-Michel AGERON advises French and foreign companies on a daily basis on the legal aspects of individual and collective labor relations as well as on social protection. He has developed expertise in corporate reorganisation operations and the implementation of jobs saving plans.',
            'He has been a lecturer for many years at Lyon 3 University for the Master 2 in Business Law and Taxation in continuing education and regularly speaks at EM Lyon.',
          ],
        },
        caroline: {
          name: 'Caroline BILLOTET',
          role: 'Associate Lawyer',
          bio: [
            'Caroline Billotet holds a Master 1 in Employment Law from Jean Moulin Lyon 3 University and a Master 2 in Sports Law from the University of Lille.',
            'After obtaining her Certificate of Aptitude to the Legal Profession, Caroline Billotet was sworn in before the Lyon Court of Appeal in December 2023.',
            'Since then, Caroline Billotet has been practicing as an associate lawyer at Valthelis Avocats, working in particular in business advisory and litigation. She participates in supporting companies in their needs related to individual and collective relations.',
            'Caroline Billotet is also a lecturer at Jean Moulin Lyon 3 University.',
          ],
        },
      },
    },
    valeurs: {
      title: 'Our Values',
      kicker: 'Our commitment at your service',
      items: [
        { title: 'Responsiveness & rigor', text: 'Responsiveness and rigor in handling every file entrusted to us.' },
        { title: 'Reliability', text: 'Reliability in the answers provided, given our specialization in employment law.' },
        { title: 'Proximity', text: 'Proximity with our clients and knowledge of their environment, history and operations.' },
        { title: 'Pragmatism', text: 'Pragmatism in implementing the recommended solutions.' },
      ],
    },
    honoraires: {
      title: 'Fees',
      kicker: 'Total transparency',
      intro: "The Firm's fees are set according to the nature and complexity of the case and are systematically announced to clients prior to the start of any work, with the establishment of a written engagement letter.",
      modesIntro: 'Several billing systems may be offered to clients:',
      modes: [
        {
          title: 'Annual subscription',
          text: 'The subscription is often used for advisory services to businesses. It allows fees to be smoothed out, defined in agreement with each client based on their needs. This option ensures regular monitoring and contributes to a privileged relationship between the lawyer and the client.',
        },
        {
          title: 'Hourly fees',
          text: 'For one-off advisory cases, fees are set on the basis of an agreed hourly rate and billed according to the time spent on the file.',
        },
        {
          title: 'Litigation flat fees',
          text: 'A flat fee covering the entire procedure is agreed with the client.',
        },
      ],
    },
    contact: {
      title: 'Contact',
      kicker: 'Stay in touch',
      intro: 'Feel free to contact us for any inquiry or to schedule a meeting.',
      addressLabel: 'Address',
      phoneLabel: 'Reception',
      emailsLabel: 'Email addresses',
      mapLabel: 'Find us',
      openInMaps: 'Open in Google Maps',
    },
  },
};
